import { createRoute, useParams } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { authenticatedRoute } from '../_authenticated';

const FormDefinitionFormPage = lazy(() =>
  import('@/features/forms/components/FormDefinitionFormPage').then((m) => ({
    default: m.FormDefinitionFormPage,
  })),
);

function FormEditPage() {
  const { formId } = useParams({ from: formEditRoute.id });

  return (
    <Suspense fallback={<LoadingSpinner label="読み込み中..." />}>
      <FormDefinitionFormPage mode="edit" formId={formId} />
    </Suspense>
  );
}

export const formEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/forms/$formId/edit',
  component: FormEditPage,
});
